import styled from "styled-components"

export const CopyAddressButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 2rem;
  border: none;
  background: transparent;
  color: ${(p) => p.theme.colors.turquoiseDark};
  font-size: 1.3rem;
  cursor: pointer;

  svg {
    height: 1.4rem;
    margin-right: 0.6rem;
    fill: ${(p) => p.theme.colors.turquoiseDark};
  }

  &:hover {
    color: ${(p) => p.theme.colors.turquoiseDarker};

    svg {
      fill: ${(p) => p.theme.colors.turquoiseDarker};
    }
  }
`
